var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "vks-data-table-view research-data-table-wrapper" },
    [
      _vm.note
        ? _c("p", { staticClass: "vks-data-table-view-note" }, [
            _vm._v(_vm._s(_vm.note)),
          ])
        : _vm._e(),
      !_vm.rows.length
        ? _c("div", { staticClass: "vks-data-table-view-empty" }, [
            _vm._v(_vm._s(_vm.emptyMessage)),
          ])
        : [
            _c("VariantSifterTableSettings", {
              attrs: {
                "per-page": _vm.perPage,
                columns: _vm.topRows,
                "visible-columns": _vm.visibleColumns,
              },
              on: {
                "update:perPage": _vm.onPerPageUpdate,
                "export-csv": _vm.exportCsv,
                "export-json": _vm.exportJson,
                "update:columnVisible": _vm.onColumnVisibleUpdate,
              },
              scopedSlots: _vm._u([
                {
                  key: "before",
                  fn: function () {
                    return [
                      _c("div", { staticClass: "vks-data-table-view-total" }, [
                        _vm._v(
                          " Total rows: " +
                            _vm._s(_vm.rows.length.toLocaleString()) +
                            " "
                        ),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _c("div", { staticClass: "vks-data-table-view-wrap" }, [
              _c(
                "table",
                {
                  staticClass: "table table-sm research-data-table",
                  attrs: { cellpadding: "0", cellspacing: "0" },
                },
                [
                  _c("thead", [
                    _c(
                      "tr",
                      [
                        _vm.showStarColumn
                          ? _c(
                              "th",
                              [
                                _c("b-icon", {
                                  staticStyle: {
                                    color: "#ffcc00",
                                    cursor: "pointer",
                                  },
                                  attrs: {
                                    icon: _vm.showStarredOnly
                                      ? "star-fill"
                                      : "star",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.showStarredOnly = !_vm.showStarredOnly
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._l(_vm.visibleTopRows, function (column) {
                          return _c(
                            "th",
                            {
                              key: column,
                              staticClass: "byor-tooltip sortable-th",
                              on: {
                                click: function ($event) {
                                  return _vm.applySorting(column)
                                },
                              },
                            },
                            [
                              _c("span", [_vm._v(_vm._s(column))]),
                              _vm.tableFormat["tool tips"]?.[column]
                                ? _c("span", { staticClass: "tooltiptext" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.tableFormat["tool tips"][column]
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                  ]),
                  _c(
                    "tbody",
                    [
                      _vm._l(_vm.pagedRows, function (row, rowIndex) {
                        return [
                          _c(
                            "tr",
                            { key: _vm.rowKey(row, rowIndex) },
                            [
                              _vm.showStarColumn
                                ? _c(
                                    "td",
                                    [
                                      _c("b-icon", {
                                        style: {
                                          color: _vm.isStarred(row)
                                            ? "#ffcc00"
                                            : "#aaaaaa",
                                          cursor: "pointer",
                                        },
                                        attrs: {
                                          icon: _vm.isStarred(row)
                                            ? "star-fill"
                                            : "star",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.$emit(
                                              "toggle-star-variant",
                                              row
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._l(_vm.visibleTopRows, function (column) {
                                return _c(
                                  "td",
                                  {
                                    key: `${_vm.rowKey(
                                      row,
                                      rowIndex
                                    )}-${column}`,
                                  },
                                  [
                                    _vm.isExpandableMappingColumn(column) &&
                                    _vm.hasMappingGroup(row, column)
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "vks-mapping-ppa-button",
                                            class: {
                                              "is-open": _vm.isMappingExpanded(
                                                row,
                                                column
                                              ),
                                            },
                                            style: {
                                              color:
                                                _vm.mappingColumnColor(column),
                                            },
                                            attrs: { type: "button" },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.toggleMappingExpand(
                                                  row,
                                                  column
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.formatExpandableValue(
                                                    row,
                                                    column
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.formatCell(row, column)
                                            ),
                                          },
                                        }),
                                  ]
                                )
                              }),
                            ],
                            2
                          ),
                          _vm.expandedPanelsForRow(row).length
                            ? _c(
                                "tr",
                                {
                                  key: `${_vm.rowKey(row, rowIndex)}-details`,
                                  staticClass: "vks-mapping-details-row",
                                },
                                [
                                  _c(
                                    "td",
                                    { attrs: { colspan: _vm.detailColspan } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "vks-mapping-details-stack",
                                        },
                                        _vm._l(
                                          _vm.expandedPanelsForRow(row),
                                          function (panel) {
                                            return _c(
                                              "VariantSifterMappingRowDetails",
                                              {
                                                key: panel.groupId,
                                                attrs: {
                                                  details: panel.details,
                                                  "group-id": panel.groupId,
                                                  title: panel.title,
                                                  utils: _vm.utils,
                                                },
                                              }
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      }),
                    ],
                    2
                  ),
                ]
              ),
            ]),
            _vm.perPage > 0
              ? _c("b-pagination", {
                  staticClass:
                    "pagination-sm justify-content-center vks-data-table-pagination",
                  attrs: {
                    "total-rows": _vm.displayRows.length,
                    "per-page": _vm.perPage,
                  },
                  model: {
                    value: _vm.currentPage,
                    callback: function ($$v) {
                      _vm.currentPage = $$v
                    },
                    expression: "currentPage",
                  },
                })
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }